import CryptoJS from 'crypto-js';

export const encrypt = (text: string, key: string) => {
  const ciphertext = CryptoJS.AES.encrypt(text, key);
  return ciphertext.toString();
};

export const decrypt = (text: string, key: string) => {
  const bytes = CryptoJS.AES.decrypt(text, key);
  return bytes.toString(CryptoJS.enc.Utf8);
};
